<template>
  <div>
    <el-image src="static/img/images10.png" class="el-image-head"/>
    <div class="div-content">
      <div class="div-content-title">
        <label class="label-title">联系我们</label>
        <div class="div-0">
          <label class="label-1">慧源创新科技有限公司(总部)</label>
        </div>
        <div class="div-1">
          <label class="label-3">服务热线:0755-23720412</label>
        </div>
        <div class="div-1">
          <label class="label-3">商务合作:李先生 15818626699</label>
        </div>
        <div class="div-1">
          <label class="label-3">地址:深圳市宝安区美生创谷科技园春谷401A区</label>
        </div>
        <baidu-map :center="center" :zoom="zoom" @ready="handler"
                   class="map-1" :scroll-wheel-zoom='true'>
        </baidu-map>
      </div>
      <div>
        <div class="div-0">
          <label class="label-1">慧源创新科技有限公司(汕头分部)</label>
        </div>
        <div class="div-1">
          <label class="label-3">地址:广东省汕头市澄海区凤翔二路, 凤新二路, 东煌创意大厦三楼</label>
        </div>
        <baidu-map :center="center2" :zoom="zoom2" @ready="handler2"
                   class="map-1" :scroll-wheel-zoom='true'>
        </baidu-map>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactUs',
  data () {
    return {
      center: {lng: 113.933751, lat: 22.582714},
      zoom: 15,
      center2: {lng: 116.801033, lat: 23.463692},
      zoom2: 15
    }
  },
  methods: {
    handler ({BMap, map}) {
      let point = new BMap.Point(113.933751, 22.582714)
      map.centerAndZoom(point, 15)
      let marker = new BMap.Marker(point) // 创建标注
      map.addOverlay(marker) // 将标注添加到地图中
      let circle = new BMap.Circle(point, 6, {
        strokeColor: 'Red',
        strokeWeight: 6,
        strokeOpacity: 1,
        Color: 'Red',
        fillColor: '#f03'
      })
      map.addOverlay(circle)
    },
    handler2 ({BMap, map}) {
      let point = new BMap.Point(116.801033, 23.463692)
      map.centerAndZoom(point, 15)
      let marker = new BMap.Marker(point) // 创建标注
      map.addOverlay(marker) // 将标注添加到地图中
      let circle = new BMap.Circle(point, 6, {
        strokeColor: 'Red',
        strokeWeight: 6,
        strokeOpacity: 1,
        Color: 'Red',
        fillColor: '#f03'
      })
      map.addOverlay(circle)
    }
  }
}
</script>

<style scoped>
.el-image-head{
  height: 541px;
  width: 100%;
}
.div-content{
  width: 60%;
  margin-top: 80px;
  margin-left: 20%;
  margin-right: 20%;
  min-height: 400px;
  padding-bottom: 80px;
}
.label-title{
  font-size: 26px;
  color: #FFB400;
  padding-bottom: 20px;
}
.div-0{
  margin-top: 30px;
  margin-left: 10px;
}
.div-1{
  margin-top: 6px;
  margin-left: 10px;
}
.label-1{
  font-size: 16px;
  font-weight: bold;
}
.label-3{
  font-size: 16px;
}
.map-1{
  height:480px;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/ContactUs.vue